// extracted by mini-css-extract-plugin
export default {"galleryThumbnail":"c-o_gy","galleryThumbnail_active":"c-o_gz","galleryThumbnail__image":"c-o_gA"};